import type { QuotesComponentLegacyProps } from './QuotesComponentLegacy';

export const QuotesComponentLegacy = {
    MountAsync: async (target: HTMLElement, props: QuotesComponentLegacyProps) => {
        const { mountReactComponentAsync } = await import('../../../js/mountReactComponentAsync');
        const { QuotesComponentLegacy } = await import('./QuotesComponentLegacy');
        return await mountReactComponentAsync(target, QuotesComponentLegacy, props);
    }
};
